// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1vKD1","colMin":"styles_colMin__2Bx2i","colCheckbox":"styles_colCheckbox__E7EJu"};